import React, {useState} from 'react';
import 'contents/assets/scss/page/main.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import ImgProfile from 'contents/assets/img/@profile.png';
import PopMemberRecommend from './_PopMemberRecommend';
function IntroduceMember() {
  const [modalMemberRecommend, setModalMemberRecommend] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', cnt: '45', value: 0},
    {title: '교무운영실', cnt: '9898', value: 1},
    {title: '출판사업부', cnt: '233', value: 2},
    {title: '전략기획실', cnt: '45', value: 3},
    {title: '입시전략부', cnt: '53', value: 4},
    {title: '경영지원실', cnt: '53', value: 5},
    {title: '부산지사', cnt: '53', value: 6}
  ];
  return (
    <main className="com_container p_intro">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu0_3">이지 직원 소개</h2>
          <button onClick={() => setModalMemberRecommend(true)} className="com_btn orange s btn_plus">
            이지 직원 소개 등록
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <div className="com_card_list">
              {[1, 2, 3, 4, 5, 6, 7, 8].map((i, idx) => {
                return (
                  <div className="card_item" key={idx}>
                    <div className="item_top">
                      <div className="info">
                        <span className="check">
                          <input type="checkbox" name="chk" id={`chk${idx}`} className="com_chk" />
                          <label htmlFor={`chk${idx}`}></label>
                        </span>
                        <p className="name">전략기획실</p>
                        <span className="dot" />
                        <p className="name">과장</p>
                        <div className="com_btn_wrap">
                          <button className="btn_message"></button>
                          <button className="btn_mail"></button>
                        </div>
                      </div>
                    </div>
                    <div className="item_mid">
                      <div className="info_area">
                        <p className="thumb">
                          <img src={ImgProfile} alt="profile" />
                        </p>
                        <div className="info_box">
                          <button className="name btn_link">홍길동103 </button>
                          <span className="desc">(본사)</span>
                          <p className="desc">배정팀, 채용팀 총괄(수학 배정)</p>
                          <ul className="detail">
                            <li className="detail_item">
                              <p className="tit">
                                <span className="dot" />
                                입사일
                              </p>
                              <p>2006.05.29 (17년차)</p>
                            </li>
                            <li className="detail_item">
                              <p className="tit">
                                <span className="dot" />
                                내선번호
                              </p>
                              <p>1231</p>
                            </li>
                            <li className="detail_item">
                              <p className="tit">
                                <span className="dot" />
                                휴대전화
                              </p>
                              <p>010-1234-2342</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="item_bt">
                      <p className="txt">EZ가 너무 좋아!</p>
                      <button className="btn_edit"></button>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="com_board_list__bottom">
              <div className="com_btn_wrap left">
                <button className="com_btn gray s">선택 항목 삭제</button>
              </div>
              <Paging />
            </div>
          </section>
        </section>
      </div>
      <PopMemberRecommend open={modalMemberRecommend} close={() => setModalMemberRecommend(false)} />
    </main>
  );
}

export default IntroduceMember;
